/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';
import { useContext } from 'react';

import { Divider } from '@coursera/cds-core';

import { SGAPageContext } from 'bundles/grading/components/staff-graded-assignments/SGAPageContext';
import AssignmentNameDisplay from 'bundles/grading/components/staff-graded-assignments/top-bar/AssignmentNameDisplay';
import DueDate from 'bundles/grading/components/staff-graded-assignments/top-bar/DueDate';

const styles = {
  container: () => css`
    display: inherit;
    align-items: center;
    overflow-y: hidden;
    margin-right: auto;
  `,
  divider: () => css`
    margin: 0 var(--cds-spacing-100);
  `,
};

// Component for SGA top bar left justified controls
const LeftControls = () => {
  const { pageData, submissionData } = useContext(SGAPageContext);

  if (!submissionData.data) {
    return null;
  }

  const assignmentName = submissionData.data?.itemName || '';

  return (
    <div css={styles.container}>
      <AssignmentNameDisplay
        courseSlug={pageData.currentCourseSlug}
        contextId={pageData.currentContextId}
        itemId={pageData.currentItemId}
        itemName={assignmentName}
      />
      {submissionData.data?.submitter && (
        <React.Fragment>
          <Divider orientation="vertical" css={styles.divider} />
          <DueDate dueDateTs={parseInt(submissionData.data.submitter.submissionDeadline.seconds, 10) * 1000} />
        </React.Fragment>
      )}
    </div>
  );
};

export default LeftControls;
